import styled from 'styled-components';

export const Button = styled.div`
  height: ${(props) => props.height || '36px'};
  width: ${(props) => props.width || 'auto'};
  min-width: ${(props) => (props.width === '100%' ? '100%' : '120px')};
  padding: ${(props) => (props.width === '100%' ? '0' : '0 20px')};
  margin: ${(props) => props.margin || '0'};
  background-color: ${(props) => {
    const style = props.buttonStyle || props.type;
    return style === 'primary' ? '#FFF28D' : '#DEDEDE';
  }};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 3px;
  cursor: pointer;
  margin-top: ${(props) => props.marginTop || '0'};
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: ${(props) => props.align || 'stretch'};
  font-size: 12px;
  font-weight: 600;
  color: #122d58;
  transition: all 0.2s ease;

  :hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0px 4px 8px #00000029;
  }

  :first-child {
    margin-right: 10px;
  }
`;

export const ButtonElement = styled.button`
  height: ${(props) => props.height || '36px'};
  width: ${(props) => props.width || 'auto'};
  min-width: ${(props) => (props.width === '100%' ? '100%' : '120px')};
  padding: ${(props) => (props.width === '100%' ? '0' : '0 20px')};
  margin: ${(props) => props.margin || '0'};
  background-color: ${(props) => {
    const style = props.buttonStyle || props.type;
    return style === 'primary' ? '#FFF28D' : '#DEDEDE';
  }};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 3px;
  cursor: pointer;
  margin-top: ${(props) => props.marginTop || '0'};
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: ${(props) => props.align || 'stretch'};
  font-size: 12px;
  font-weight: 600;
  color: #122d58;
  transition: all 0.2s ease;
  border: none;
  outline: none;

  :hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0px 4px 8px #00000029;
  }

  :first-child {
    margin-right: 10px;
  }
`;

export const Icon = styled.img`
  margin-right: 10px;
  width: 15px;
  height: 15px;
`;
